import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsCreateTeamMember, IResponseCreateTeamMember } from "./types"
import { useApi } from "../../useApi"
import { CreateTeamMemberURL } from "../../../utils/constants"
import { Dispatch, SetStateAction, useContext } from "react"
import { ToastMessageContext } from "@context/toast-message-cotnext"
import { useTranslation } from "react-i18next"
async function postCreateTeamMember(
	responseData: IPropsCreateTeamMember,
	apiPrivate: AxiosInstance,
	showError: Dispatch<SetStateAction<string | undefined>>,
	language: string
): Promise<AxiosResponse<IResponseCreateTeamMember>> {
	try {
		const response: AxiosResponse<IResponseCreateTeamMember> =
			await apiPrivate.post(`${CreateTeamMemberURL}`, { ...responseData })

		return response
	} catch (error: any) {
		showError(
			error.response?.data?.errorMessages
				.map((item: any) =>
					language === "ar" ? item.messageAr : item.messageEn
				)
				.join(", ")
		)
		return error
	}
}

export function usePostCreateTeamMember(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseCreateTeamMember>,
					unknown,
					unknown,
					AxiosResponse<IResponseCreateTeamMember>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { showError, showSuccess } = useContext(ToastMessageContext)
	const {
		i18n: { language },
	} = useTranslation()
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsCreateTeamMember) =>
			postCreateTeamMember(data, apiPrivate, showError, language),
		...options,
	})
	return mutation
}
